// components/PageHeader.js
import { useEffect } from 'react';
import { useHeader } from '@seims/shared';

export const PageHeaderControl = ({
  title = "Events Management",
  showBack = true,
  showConfirmBack = false,
  onBack,
  children,
  resetOnUnmount = true,
  headerClassName = undefined,
}) => {
  const { setHeader, resetHeader } = useHeader();  
  useEffect(() => {
    setHeader({
      title,
      showBack,
      showConfirmBack,
      onBack,
      headerClassName
    });
    return () => {
      if (resetOnUnmount) {
        resetHeader();
      }
    };
  }, [title, showBack, showConfirmBack, onBack, setHeader, resetHeader, resetOnUnmount, headerClassName]);

  return (children);
};
